import { Box, Grid, Typography } from "@mui/material";
import BAScreenHeader from "../config/components/BAScreenHeader";
import { Get } from "../config/apimethods/apimethods";
import { useEffect, useState } from "react";
import BAGrid from "../config/components/BAGrid";
import BAInput from "../config/components/BAInput";
import BAButton from '../config/components/BAButton'
import BAModal from "../config/components/BAModal";

export default function ProductInventory() {

    const [productsList, setProductsList] = useState([])
    const [loader, setLoader] = useState(false)
    const [message, setMessage] = useState()
    const [showMessage, setShowMessae] = useState()
    const [selectedList, setSelectedList] = useState([])
    const [updatedList, setUpdatedList] = useState([])
    const [openModal, setOpenModal] = useState(false)

    const getProducts = () => {
        setLoader(true)
        Get('product').then(res => {
            setLoader(false)
            setProductsList([...res.data])
        }).catch(err => {
            setLoader(false)
            setMessage(err.message)
            setShowMessae(true)
        })
    }

    const addItem = (e) => {
        let exist = selectedList.find(x => x._id == e._id)
        if (!exist) {
            setSelectedList([...selectedList, {
                name: e.name,
                code: e.code,
                quantityInStock: e.quantityInStock,
                stockOut: 0,
                stockIn: 0,
                _id: e._id
            }])
        }
    }

    useEffect(() => {
        getProducts()
    }, [])

    let addInventory = () => {
        let arr = []
        for (let i = 0; i < selectedList.length; i++) {
            let x = { ...selectedList[i] }
            x.quantityInStock = x.quantityInStock - (+x.stockOut || 0)
            x.quantityInStock = x.quantityInStock + (+x.stockIn || 0)
            arr.push({ ...x })
        }
        setUpdatedList([...arr])
        setOpenModal(true)
    }

    let saveInventory = () => {
        console.log(updatedList)
    }


    return <>
        <BAModal modalTitle='Stock Update' innerContent={<Box>
            <BAGrid datasource={updatedList} gridCols={[
                {
                    key: 'name',
                    label: 'Product Name'
                },
                {
                    key: 'code',
                    label: 'Product Code'
                },
                {
                    key: 'quantityInStock',
                    label: 'Updated Stock After Entry'
                },
                {
                    key: 'stockOut',
                    label: 'Stock Out'
                },
                {
                    key: 'stockIn',
                    label: 'Stock In'
                },
            ]} />
        </Box>} modalFooter={<Box className="text-center">
            <BAButton onClick={saveInventory} label='save' />
        </Box>} open={openModal} close={(e) => setOpenModal(e)} />
        <Box>
            <BAScreenHeader title='Product Inventory' buttonsList={[
                {
                    displayField: <BAButton onClick={addInventory} label='Add Inventory' />
                }
            ]} />
        </Box>
        <Box>
            <Grid container>
                <Grid item md={3}>
                    <Box>
                        {productsList.map((x, i) => <Box key={i} onClick={() => addItem(x)} className="d-flex cursor-pointer justify-content-between p-2 bgLight mb-1 rounded">
                            <Typography>{x.name}</Typography>
                            <Typography>{x.quantityInStock}{x.unit}</Typography>
                        </Box>)}
                    </Box>
                </Grid>
                <Grid item md={9}>
                    <Box className="p-2">
                        <BAGrid datasource={selectedList} gridCols={[
                            {
                                key: 'name',
                                label: 'Name',
                            },
                            {
                                key: 'code',
                                label: 'Code',
                            },
                            {
                                key: 'quantityInStock',
                                label: 'Quantity in Stock',
                            },
                            {
                                key: 'stockOut',
                                label: 'Stock Out',
                                displayField: (e) => <BAInput onChange={(ev) => {
                                    e.stockOut = ev.target.value
                                    setSelectedList([...selectedList])
                                }} value={e.stockOut} type='number' />
                            },
                            {
                                key: 'stockIn',
                                label: 'Stock In',
                                displayField: (e) => <BAInput onChange={(ev) => {
                                    e.stockIn = ev.target.value
                                    setSelectedList([...selectedList])
                                }} value={e.stockIn} type='number' />
                            },
                        ]} />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    </>
}